import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgEstudios1 from "../../assets/tests/scn2/retro-1.jpg";
import imgEstudios2 from "../../assets/tests/scn2/retro-2.jpg";
import imgEstudios3 from "../../assets/tests/scn2/retro-3.jpg";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconVocabulary } from "@tabler/icons-react";
import flechaRetroceder from "../../assets/left-arrow.svg";
import flechaAvanzar from "../../assets/right-arrow.svg";

function Scenario2Retroalimentacion({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  // 👇 estado para manejar qué slide está activo
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array de imágenes
  const images = [imgEstudios1, imgEstudios2, imgEstudios3];

  const handleNext = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // Última imagen → saltar a CLASIFICACION
      navigate(ROUTES.SCENARIO2_CLASIFICACION, { state: { activeScenario } });
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const texts = [
    "Texto de retroalimentación sobre los estudios de extensión realizados al paciente. Aquí se puede incluir información relevante que ayude al usuario a comprender mejor los resultados obtenidos y su implicación en el diagnóstico y tratamiento del paciente.",
    "Texto para la segunda...",
    "Texto final antes de la clasificación..."
  ];

  return (
    <div className="h-100">
      <div className="container-fluid h-100">
        <div className="row h-100">
          {/* Columna izquierda con retroalimentación */}
          <div
            className="col-md-5 d-flex justify-content-start align-items-center ps-5 pt-5"
            style={{ marginBottom: "2vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100">
              <p className="txt30 txt-purple bold" style={{ backgroundColor: "#FFFFFFAA", borderRadius: "10px", padding: "20px"}}>
                Retroalimentación estudios de extensión
              </p>
              <p
                className="position-relative txt24 mt-3"
                style={{
                  padding: "20px",
                  lineHeight: "1.6",
                  border: "1px solid #ffcdd0ba",
                  borderRadius: "8px",
                  overflow: "hidden",
                  height: "270px",
                  width: "100%",
                }}
              >
                {texts[currentIndex]}
                <IconVocabulary
                  size={100}
                  color="#000000"
                  stroke={1}
                  className="position-absolute"
                  style={{
                    top: "0px",
                    right: "0px",
                    opacity: 0.1,
                    pointerEvents: "none",
                  }}
                />
              </p>

              {/* Dots indicadores */}
              <div className="d-flex justify-content-center align-items-center mt-2 w-100">
                {images.map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      margin: "0 4px",
                      backgroundColor: idx === currentIndex ? "#d9534f" : "#ccc",
                    }}
                  ></div>
                ))}
              </div>

              {/* Botones de navegación */}
              <div className="d-flex justify-content-between mt-3 w-100">
                {currentIndex > 0 ? (
                  <div className="d-flex justify-content-end align-items-center">
                    <button
                    onClick={handlePrev}
                      className="btn-main bgOrange"
                      style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      }}
                    >
                      <img
                      src={flechaRetroceder}
                      alt="Anterior"
                      style={{ maxWidth: "40px" }}
                      />
                    </button>
                    <div className="txt24 orange bold ms-3">
                      Anterior
                    </div>           
                  </div>
                ) : (
                  <div style={{ width: "50px" }}></div>
                )}
                <div className="d-flex justify-content-end align-items-center">
                  <div className="txt24 orange bold me-3">
                    Siguiente
                  </div>
                  <button
                    onClick={handleNext}
                    className={`btn-main bold txt22 bgOrange`}
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                    }}
                  >
                      <img
                      src={flechaAvanzar  }
                      alt="Anterior"
                      style={{ maxWidth: "40px" }}
                      />
                  </button>             
                </div>
              </div>
            </div>
          </div>

          {/* Columna derecha con imágenes */}
          <div
            className={`col-md-7 d-flex h-100 justify-content-center ${
              currentIndex === 2 ? "align-items-start pt-4" : "align-items-center"
            }`}
          >
            <img
              src={images[currentIndex]}
              className="rounded shadow"
              style={{ maxWidth: "95%", borderRadius: "12px", maxHeight: "85%" }}
              alt="Estudio"
            />
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario2Retroalimentacion);
